module.exports = __webpack_public_path__ + "img/7740407.1ea87ae1.jpg";